import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import * as _ from "../../../util/lodash";
import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import moment from 'moment';
import { ConfigService } from "../../../services";
import assetRefService from "../../../util/asset";
import { positions, sizes, widths, documentTypes as DOCUMENT_TYPES, icons, assetServices, uploadAssetTypes } from "../../../enums";
import { UploaderMessages, prettyFileSize } from "./file-utils";
import Button from "../button";
import Layout from "../layout";
import Icon from "../icon";
import ContentItem from "../../abstractions/content-item";
import LibrarySelect from "../../abstractions/library-select";
import AssetPreview from "./asset-preview";
import AssetOverview from "./asset-overview";
import ItemThumbnail from "./item-thumbnail";
/**
 * displays thumbnail and meta info of an existing(already uploaded) file or video url
 */

var FileOverview = createComponent({
  displayName: 'FileOverview',
  state: {
    previewModalVisible: {
      value: false,
      updater: function updater(setPreviewModalVisible) {
        return {
          showPreviewModal: function showPreviewModal() {
            return setPreviewModalVisible(true);
          },
          hidePreviewModal: function hidePreviewModal() {
            return setPreviewModalVisible(false);
          }
        };
      }
    }
  },
  propTypes: {
    file: PropTypes.object.isRequired,
    onReplaceVideo: PropTypes.func.isRequired,
    onRemoveFile: PropTypes.func.isRequired,
    showSelectButton: PropTypes.bool.isRequired,
    onSelectFromLibrary: PropTypes.func.isRequired,
    libraryRef: PropTypes.string.isRequired,
    containerRef: PropTypes.string.isRequired,
    documentTypes: PropTypes.array.isRequired,
    displayFilterScope: PropTypes.bool.isRequired,
    onFileSelected: PropTypes.func.isRequired
  },
  render: function render(p) {
    var ConsoleKitConfig = _valuesInstanceProperty(ConfigService).call(ConfigService);

    var file = p.file,
        onReplaceVideo = p.onReplaceVideo,
        onRemoveFile = p.onRemoveFile,
        displayFilterScope = p.displayFilterScope,
        assetMeta = file.assetMeta,
        assetRefObj = assetRefService.deserialize(file.assetRef),
        isVideoAsset = assetRefObj.service === assetServices.WEB_URL && assetRefObj.assetType === uploadAssetTypes.VIDEO_URL;
    var previewHeader = '',
        previewByline = '',
        fileDetails = '',
        metaHeader = '',
        metaByline = '',
        metaResolution = '';

    if (isVideoAsset) {
      previewHeader = metaHeader = UploaderMessages.VIDEO_HEADLINE;
      previewByline = metaByline = assetRefObj.location;
    } else {
      var lastUpdated = assetMeta.lastUpdated && moment(assetMeta.lastUpdated).isBefore(moment() - 1000) ? moment(assetMeta.lastUpdated).fromNow() : 'a few seconds ago',
          modifiedBy = assetMeta.modifiedBy && assetMeta.modifiedBy.name ? 'Modified by ' + assetMeta.modifiedBy.name + ' ' + lastUpdated : '';
      var fileDetailsArr = [assetMeta.classRef && assetMeta.classRef.label, assetMeta.mimeType && assetMeta.mimeType.label, assetMeta.fileSize && prettyFileSize(assetMeta.fileSize), assetMeta.fileName, assetMeta.fileName, modifiedBy];
      fileDetails = _filterInstanceProperty(_).call(_, fileDetailsArr, function (v) {
        return !!v;
      }).join(' | ');
      previewHeader = assetMeta.name;
      previewByline = fileDetails;
      metaHeader = assetMeta.name || '';
      metaByline = fileDetails;
      metaResolution = assetMeta.height ? assetMeta.width + 'x' + assetMeta.height : '';
    }

    return /*#__PURE__*/React.createElement("div", {
      className: "upload-view file-overview"
    }, /*#__PURE__*/React.createElement(AssetPreview, {
      previewModalVisible: p.previewModalVisible,
      hidePreviewModal: p.hidePreviewModal,
      headerText: previewHeader,
      bylineText: previewByline,
      assetPath: assetMeta.assetPath + "?rnd=" + assetMeta.lastUpdated,
      assetRefObj: assetRefObj
    }), !isVideoAsset ? /*#__PURE__*/React.createElement(AssetOverview, {
      thumbnailContent: /*#__PURE__*/React.createElement(ItemThumbnail, {
        metaWidth: assetMeta && assetMeta.width || file.resolution && file.resolution.width || 0,
        metaHeight: assetMeta && assetMeta.height || file.resolution && file.resolution.height || 0,
        imageSrc: assetMeta.thumbnailAssetPath + "?rnd=" + assetMeta.lastUpdated,
        tooltip: assetMeta.name
      }),
      metaContent: /*#__PURE__*/React.createElement(ContentItem, {
        header: metaHeader,
        byline: metaByline,
        meta: metaResolution
      })
    }) : isVideoAsset ? /*#__PURE__*/React.createElement(AssetOverview, {
      thumbnailContent: /*#__PURE__*/React.createElement("div", {
        className: "video-url-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: icons.VIDEO,
        size: sizes.X3
      })),
      metaContent: /*#__PURE__*/React.createElement(ContentItem, {
        header: metaHeader,
        byline: metaByline,
        meta: metaResolution
      })
    }) : null, /*#__PURE__*/React.createElement("div", {
      className: "file-actions-wrapper"
    }, /*#__PURE__*/React.createElement(Layout, {
      isFluidHeight: true,
      columns: widths.ONE,
      padding: null,
      columnStyles: {
        verticalAlign: positions.verticalAlign.MIDDLE
      }
    }, /*#__PURE__*/React.createElement(Button.Group, null, isVideoAsset ? /*#__PURE__*/React.createElement(Button.Primary, {
      text: UploaderMessages.ACTION_REPLACE,
      onClick: onReplaceVideo
    }) : p.showSelectButton && !isVideoAsset ? /*#__PURE__*/React.createElement(LibrarySelect.Modal, {
      onClick: _.noop,
      trigger: /*#__PURE__*/React.createElement(Button.Primary, {
        text: UploaderMessages.ACTION_REPLACE
      }),
      onAssetSelected: p.onSelectFromLibrary,
      libraryRef: p.libraryRef,
      containerRef: p.containerRef,
      documentTypes: p.documentTypes,
      CKConfig: ConsoleKitConfig,
      displayFilterScope: displayFilterScope,
      onFileSelected: p.onFileSelected
    }) : null, /*#__PURE__*/React.createElement(Button.Primary, {
      text: UploaderMessages.ACTION_REMOVE,
      onClick: onRemoveFile
    }), file.docType === DOCUMENT_TYPES.IMAGE || isVideoAsset ? /*#__PURE__*/React.createElement(Button.Primary, {
      text: UploaderMessages.ACTION_PREVIEW,
      onClick: p.showPreviewModal
    }) : null))));
  }
});
export default FileOverview;
//# sourceMappingURL=file-overview.js.map